import * as React from 'react';
import { Component, ComponentProps, inject, deps, observer } from '../../../lib/component';
import { PageError } from './PageError';

interface ErrorBoundaryProps extends ComponentProps {
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

@inject(deps)
@observer
export class ErrorBoundary extends Component<ErrorBoundaryProps, { hasError: boolean }> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };

    this.resetErrorState = this.resetErrorState.bind(this);
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    const { bugsnag } = this.props.controller;
    bugsnag.notifyExceptionSafely(error);
  }

  resetErrorState() {
    this.setState({ hasError: false });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.fallback || <PageError onReload={this.resetErrorState} />;
    }

    return this.props.children;
  }
}
